import React from "react";
import cloudfrontConversion from "../utils/cloudfrontConversion";

const generatePosterUrl = (poster) => {
    const posterUrl = poster.filename.replace("https://a.storyblok.com/", "")
    return `https://img2.storyblok.com/filters:quality(50)/${posterUrl}`
}

const Video = (props) => {

    // get low quality image for poster from poster.filename
    // from: https://a.storyblok.com/f/210848/2880x1338/05f6337b1d/frank_desktop_slide.jpg 
    // to: https://img2.storyblok.com/1040x483/filters:quality(10)/f/210848/2880x1338/05f6337b1d/frank_desktop_slide.jpg

    // 
    let posterImage = null;
    if (props.poster.filename) {
        posterImage = generatePosterUrl(props.poster);
        posterImage = cloudfrontConversion(posterImage);
    }
    let videoUrl = props.video.filename
    videoUrl = cloudfrontConversion(videoUrl)

    return (
        <video
            className={props.className}
            src={videoUrl}
            autoPlay={true}
            muted={true}
            loop={true}
            playsInline={true}
            disablePictureInPicture={true}
            disableRemotePlayback={true}
            poster={posterImage}
        ></video>
    )
}

export default Video